import React, { useEffect, useRef, useState } from 'react';

import {
  ArrowDown,
  ArrowRight,
  ArrowUpRight,
  Buildings,
  Car,
  Cube,
  CurrencyCircleDollar,
  Database,
  Factory,
  GlobeHemisphereWest,
  MapPinLine,
  Plant,
  PlayCircle,
  // ShoppingCartSimple,
  Target,
  Timer,
  TreeStructure,
  Truck,
} from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import icon from 'src/assets/4i-icon.svg';
import agroSector from 'src/assets/agro-sector.png';
import background from 'src/assets/background-landing.svg';
import { ReactComponent as BlueCircle } from 'src/assets/blue-circle.svg';
import businessIcon from 'src/assets/business-icon.svg';
import { ReactComponent as ChartLine } from 'src/assets/chart-line.svg';
import classification from 'src/assets/classification.svg';
import concessionairesSector from 'src/assets/concessionaires-sector.png';
// import geolocation from 'src/assets/geolocation.svg';
import freeIcon from 'src/assets/free-icon.svg';
import industriesSector from 'src/assets/industries-sector.png';
import logisticsSector from 'src/assets/logistics-sector.png';
import { ReactComponent as PinkCircle } from 'src/assets/pink-circle.svg';
// import retailSector from 'src/assets/retail-sector.png';
import timeSeries from 'src/assets/time-series.svg';
import videoThumb from 'src/assets/video-thumb.svg';
import { Button } from 'src/components/Button';
import { ContactSales } from 'src/components/ContactSales';
import { Description } from 'src/components/Description/styles';
import { Head } from 'src/components/Head';
import { Modal } from 'src/components/Modal';
import { Skeleton } from 'src/components/Skeleton';
import { Title } from 'src/components/Title/styles';
import light from 'src/styles/themes/light';
import {
  TrackGoogleAnalyticsEvent,
  TrackGoogleAnalyticsPageView,
} from 'src/utils/google-analytics';
import { scrollTo } from 'src/utils/scrollTo';

import { CarouselTab } from './components/CarouselTab';
import { Cases } from './components/Cases';
import {
  CircleContent,
  Container,
  DepartmentContainer,
  DepartmentContent,
  ModelingCard,
  ModelingContainer,
  ModelingContent,
  PlatformContainer,
  PlatformContent,
  SloganContainer,
  SloganContent,
  TabContent,
  AboutContainer,
  AboutContent,
  AboutCard,
  CasesContainer,
  CasesContent,
  VideoContainer,
  VideoContent,
  PlansContainer,
  PlansContent,
  PlanCard,
  Background,
} from './styles';

export function Landing() {
  const [openVideo, setOpenVideo] = useState(false);
  const [videoIsLoading, setVideoIsLoading] = useState(true);
  const videoRef = useRef(null);

  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    TrackGoogleAnalyticsPageView(location.pathname, 'Tela Inicial');
  }, [location.pathname]);

  useEffect(() => {
    let startTyping = true;

    const words = ['forecasts', 'models', 'data'];

    const span = document?.getElementById('better-type');

    let i = 0;

    function typingEffect() {
      const word = words[i].split('');

      function loopTyping() {
        if (!startTyping) return;

        if (word.length > 0) {
          if (span) {
            span.innerHTML += word.shift();
          }
        } else {
          setTimeout(deletingEffect, 1000);
          return;
        }

        setTimeout(loopTyping, 150);
      }

      loopTyping();
    }

    function deletingEffect() {
      const word = words[i].split('');

      function loopDeleting() {
        if (!startTyping) return;

        if (word.length > 0) {
          word.pop();

          if (span) {
            span.innerHTML = word.join('');
          }
        } else {
          if (words.length > i + 1) i++;
          else i = 0;

          setTimeout(typingEffect, 200);
          return;
        }
        setTimeout(loopDeleting, 100);
      }
      loopDeleting();
    }

    typingEffect();

    return () => {
      startTyping = false;
      if (span) span.innerHTML = '';
    };
  }, []);

  // const widthScreen = window.innerWidth;

  const pauseVideo = () => {
    const video = videoRef.current as any;

    if (video) {
      if (video?.contentWindow?.postMessage) {
        video.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*',
        );
      }
    }
  };

  useEffect(() => {
    if (!openVideo) {
      pauseVideo();
    }
  }, [openVideo]);

  return (
    <Container>
      <Head
        title={translate('landingPageHeadTitle')}
        description={translate('landingPageHeadDescription') ?? ''}
      />

      <Background>
        <img src={background} alt="background" />
      </Background>

      {/* <SVG>
        <Circle
          cx="51%"
          cy="52%"
          r={widthScreen > 768 ? '27%' : '42%'}
          className="pink-circle"
        />
        <Circle
          cx="49%"
          cy="50%"
          r={widthScreen > 768 ? '26%' : '39%'}
          className="blue-circle"
        />
      </SVG> */}

      <SloganContainer>
        <SloganContent>
          <h1>
            Better <span id="better-type" />,
          </h1>
          <h1>better decisions</h1>

          <p>{translate('landingPageSlogan')}</p>

          <Button
            buttonType="primary"
            icon={<ArrowUpRight />}
            onClick={() => {
              TrackGoogleAnalyticsEvent(
                'Comece grátis',
                'Ir para cadastro do freemium',
                location.pathname,
              );
              navigate('/freemium/sign-up');
            }}
            data-testid="start-free-button"
          >
            Comece grátis
          </Button>

          <button
            type="button"
            aria-label={translate('landingPageDownButtonLabel') ?? ''}
            onClick={() => {
              TrackGoogleAnalyticsEvent(
                'Seta para próximo conteúdo',
                'Ir para o próximo conteúdo da landing page',
                location.pathname,
              );
              scrollTo(false, window.innerHeight + 230, 30);
            }}
          >
            <ArrowDown weight="light" />
          </button>
        </SloganContent>
      </SloganContainer>

      <PlatformContainer>
        <Title>
          <h3>{translate('landingPagePlatformSubtitle')}</h3>
          <h1>{translate('landingPagePlatformTitle')}</h1>
        </Title>

        <Description>
          <p>{translate('landingPagePlatformDescription1')}</p>

          <p>{translate('landingPagePlatformDescription2')}</p>
        </Description>

        <PlatformContent>
          <PinkCircle className="platform-pink-circle" />
          <BlueCircle className="platform-blue-circle" />

          <img src={icon} alt="4intelligence icon" className="company-icon" />

          <CircleContent
            className="pink-circle-content"
            style={{ textAlign: 'right' }}
          >
            <div className="pink-icons">
              <GlobeHemisphereWest weight="duotone" />
              <CurrencyCircleDollar weight="duotone" />
              <Buildings weight="duotone" />
              <ArrowRight />
              <Database weight="duotone" className="dark-pink-icon" />
            </div>

            <p>{translate('landingPagePlatformFS')}</p>
          </CircleContent>

          <CircleContent className="blue-circle-content">
            <div className="blue-icons">
              <Cube weight="duotone" className="dark-blue-icon" />
              <ArrowRight />
              <ChartLine />
              <MapPinLine weight="duotone" />
              <TreeStructure weight="duotone" />
            </div>

            <p>{translate('landingPagePlatformModels')}</p>
          </CircleContent>
        </PlatformContent>
      </PlatformContainer>

      <ModelingContainer>
        <Title>
          <h3>{translate('landingPageModelingSubtitle')}</h3>
          <h1>{translate('landingPageModelingTitle')}</h1>
        </Title>

        <Description>
          <p>{translate('landingPageModelingDescription')}</p>
        </Description>

        <ModelingContent>
          <ModelingCard className="time-series">
            <img
              src={timeSeries}
              alt={translate('landingPageModelingTimeImageAlt') ?? ''}
            />

            <h3 style={{ color: light.colors.purple4 }}>
              {translate('landingPageModelingTimeSubtitle')}
            </h3>

            <h1>{translate('landingPageModelingTimeTitle')}</h1>

            <p>{translate('landingPageModelingTimeDescription')}</p>
          </ModelingCard>

          <ModelingCard className="classification">
            <img
              src={classification}
              alt={translate('landingPageModelingClassificationImageAlt') ?? ''}
            />

            <h3 style={{ color: light.colors.teal4 }}>
              {translate('landingPageModelingClassificationSubtitle')}
            </h3>

            <h1>{translate('landingPageModelingClassificationTitle')}</h1>

            <p>{translate('landingPageModelingClassificationDescription')}</p>
          </ModelingCard>

          {/* <ModelingCard className="geolocation">
            <img
              src={geolocation}
              alt={translate('landingPageModelingLocationImageAlt') ?? ''}
            />

            <h3 style={{ color: light.colors.orange4 }}>
              {translate('landingPageModelingLocationSubtitle')}
            </h3>

            <h1>{translate('landingPageModelingLocationTitle')}</h1>

            <p>{translate('landingPageModelingLocationDescription')}</p>
          </ModelingCard> */}
        </ModelingContent>
      </ModelingContainer>

      <DepartmentContainer>
        <Title>
          <h3>{translate('landingPageDepartmentSubtitle')}</h3>
          <h1>{translate('landingPageDepartmentTitle')}</h1>
        </Title>

        <DepartmentContent>
          <CarouselTab
            data={[
              {
                id: 'agribusiness-tab',
                icon: <Plant weight="duotone" />,
                color: light.colors.green4,
                render: () => (
                  <TabContent color={light.colors.green4}>
                    <div>
                      <h3>{translate('landingPageDepartmentSolution')}</h3>

                      <h1>
                        {translate('landingPageDepartmentType')}
                        <span>
                          {translate('landingPageDepartmentAgribusiness')}
                        </span>
                      </h1>

                      <p>
                        {translate(
                          'landingPageDepartmentAgribusinessDescription',
                        )}
                      </p>

                      <ul>
                        <li>
                          {translate('landingPageDepartmentAgribusinessList1')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentAgribusinessList2')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentAgribusinessList3')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentAgribusinessList4')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentAgribusinessList5')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentAgribusinessList6')}
                        </li>
                      </ul>
                    </div>
                    <div>
                      <img
                        src={agroSector}
                        alt={
                          translate(
                            'landingPageDepartmentAgribusinessImageAlt',
                          ) ?? ''
                        }
                      />
                    </div>
                  </TabContent>
                ),
              },
              {
                id: 'concessionaires-tab',
                icon: <Car weight="duotone" />,
                color: light.colors.purple4,
                render: () => (
                  <TabContent color={light.colors.purple4}>
                    <div>
                      <h3>{translate('landingPageDepartmentSolution')}</h3>

                      <h1>
                        {translate('landingPageDepartmentType')}
                        <span>
                          {translate('landingPageDepartmentConcessionaires')}
                        </span>
                      </h1>

                      <p>
                        {translate(
                          'landingPageDepartmentConcessionairesDescription',
                        )}
                      </p>

                      <ul>
                        <li>
                          {translate(
                            'landingPageDepartmentConcessionairesList1',
                          )}
                        </li>
                        <li>
                          {translate(
                            'landingPageDepartmentConcessionairesList2',
                          )}
                        </li>
                        <li>
                          {translate(
                            'landingPageDepartmentConcessionairesList3',
                          )}
                        </li>
                        <li>
                          {translate(
                            'landingPageDepartmentConcessionairesList4',
                          )}
                        </li>
                        <li>
                          {translate(
                            'landingPageDepartmentConcessionairesList5',
                          )}
                        </li>
                        <li>
                          {translate(
                            'landingPageDepartmentConcessionairesList6',
                          )}
                        </li>
                      </ul>
                    </div>
                    <div>
                      <img
                        src={concessionairesSector}
                        alt={
                          translate(
                            'landingPageDepartmentConcessionairesImageAlt',
                          ) ?? ''
                        }
                      />
                    </div>
                  </TabContent>
                ),
              },
              {
                id: 'industries-tab',
                icon: <Factory weight="duotone" />,
                color: light.colors.gray5,
                render: () => (
                  <TabContent color={light.colors.gray5}>
                    <div>
                      <h3>{translate('landingPageDepartmentSolution')}</h3>

                      <h1>
                        {translate('landingPageDepartmentType')}
                        <span>
                          {translate('landingPageDepartmentIndustries')}
                        </span>
                      </h1>

                      <p>
                        {translate(
                          'landingPageDepartmentIndustriesDescription',
                        )}
                      </p>

                      <ul>
                        <li>
                          {translate('landingPageDepartmentIndustriesList1')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentIndustriesList2')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentIndustriesList3')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentIndustriesList4')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentIndustriesList5')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentIndustriesList6')}
                        </li>
                      </ul>
                    </div>
                    <div>
                      <img
                        src={industriesSector}
                        alt={
                          translate(
                            'landingPageDepartmentIndustriesImageAlt',
                          ) ?? ''
                        }
                      />
                    </div>
                  </TabContent>
                ),
              },
              {
                id: 'logistics-tab',
                icon: <Truck weight="duotone" />,
                color: light.colors.teal4,
                render: () => (
                  <TabContent color={light.colors.teal4}>
                    <div>
                      <h3>{translate('landingPageDepartmentSolution')}</h3>

                      <h1>
                        {translate('landingPageDepartmentType')}
                        <span>
                          {translate('landingPageDepartmentLogistics')}
                        </span>
                      </h1>

                      <p>
                        {translate('landingPageDepartmentLogisticsDescription')}
                      </p>

                      <ul>
                        <li>
                          {translate('landingPageDepartmentLogisticsList1')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentLogisticsList2')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentLogisticsList3')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentLogisticsList4')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentLogisticsList5')}
                        </li>
                        <li>
                          {translate('landingPageDepartmentLogisticsList6')}
                        </li>
                      </ul>
                    </div>
                    <div>
                      <img
                        src={logisticsSector}
                        alt={
                          translate('landingPageDepartmentLogisticsImageAlt') ??
                          ''
                        }
                      />
                    </div>
                  </TabContent>
                ),
              },
              // {
              //   id: 'retail-tab',
              //   icon: <ShoppingCartSimple weight="duotone" />,
              //   color: light.colors.secondary,
              //   render: () => (
              //     <TabContent color={light.colors.secondary}>
              //       <div>
              //         <h3>{translate('landingPageDepartmentSolution')}</h3>

              //         <h1>
              //           {translate('landingPageDepartmentType')}
              //           <span>{translate('landingPageDepartmentRetail')}</span>
              //         </h1>

              //         <p>
              //           {translate('landingPageDepartmentRetailDescription')}
              //         </p>

              //         <ul>
              //           <li>{translate('landingPageDepartmentRetailList1')}</li>
              //           <li>{translate('landingPageDepartmentRetailList2')}</li>
              //           <li>{translate('landingPageDepartmentRetailList3')}</li>
              //           <li>{translate('landingPageDepartmentRetailList4')}</li>
              //           <li>{translate('landingPageDepartmentRetailList5')}</li>
              //           <li>{translate('landingPageDepartmentRetailList6')}</li>
              //         </ul>
              //       </div>
              //       <div>
              //         <img
              //           src={retailSector}
              //           alt={
              //             translate('landingPageDepartmentLogisticsImageAlt') ??
              //             ''
              //           }
              //         />
              //       </div>
              //     </TabContent>
              //   ),
              // },
            ]}
          />
        </DepartmentContent>
      </DepartmentContainer>

      <PlansContainer>
        <Title>
          <h3>Para cada necessidade</h3>

          <h1>Nós temos o plano perfeito para você</h1>
        </Title>

        <PlansContent>
          <div>
            <PlanCard>
              <div>
                <img
                  src={freeIcon}
                  alt="Ícone da base de dados representando o plano free"
                />
              </div>

              <h4 style={{ color: light.colors.secondary }}>
                Base de dados integrada
              </h4>

              <h2>Free</h2>

              <p>
                Acesso restrito à nossa base de dados, com informações de
                diversos setores, sempre atualizadas e prontas pra uso.
              </p>
            </PlanCard>

            <PlanCard>
              <div>
                <img
                  src={businessIcon}
                  alt="Ícone da base de dados e do motor de modelagem representando o plano business"
                />
              </div>

              <h4>
                <span style={{ color: light.colors.secondary }}>
                  Base de dados
                </span>{' '}
                +{' '}
                <span style={{ color: light.colors.primary }}>
                  motor de modelagem
                </span>
              </h4>

              <h2>Business</h2>

              <p>
                Acesso completo à nossa base de dados e ao motor de modelagem
                com suporte de especialistas em inteligência econômica.
              </p>
            </PlanCard>
          </div>

          <Button
            buttonType="tertiary"
            icon={<ArrowUpRight />}
            onClick={() => {
              TrackGoogleAnalyticsEvent(
                'Saiba mais',
                'Ir para a tela de planos',
                location.pathname,
              );
              navigate('/plans');
            }}
            data-testid="know-more-plans-button"
          >
            Saiba mais
          </Button>
        </PlansContent>
      </PlansContainer>

      <AboutContainer>
        <Title>
          <h3>{translate('landingPageAboutSubtitle')}</h3>
          <h1>{translate('landingPageAboutTitle')}</h1>
        </Title>

        <Description>
          <p>{translate('landingPageAboutDescription')}</p>
        </Description>

        <AboutContent>
          <AboutCard
            color={light.colors.primary}
            backgroundColor="rgba(129, 179, 255, 0.3)"
          >
            <Database weight="duotone" />

            <h1>{translate('landingPageAboutDatabaseTitle')}</h1>
            <p>{translate('landingPageAboutDatabaseDescription')}</p>
          </AboutCard>

          <AboutCard
            color={light.colors.secondary}
            backgroundColor="rgba(242, 125, 180, 0.3)"
          >
            <Target weight="duotone" />

            <h1>{translate('landingPageAboutApplicationTitle')}</h1>
            <p>{translate('landingPageAboutApplicationDescription')}</p>
          </AboutCard>

          <AboutCard
            color={light.colors.purple4}
            backgroundColor="rgba(159, 122, 234, 0.3)"
          >
            <Timer weight="duotone" />

            <h1>{translate('landingPageAboutAgilityTitle')}</h1>
            <p>{translate('landingPageAboutAgilityDescription')}</p>
          </AboutCard>
        </AboutContent>
      </AboutContainer>

      <CasesContainer>
        <Title>
          <h3>{translate('landingPageCasesSubtitle')}</h3>
          <h1>{translate('landingPageCasesTitle')}</h1>
        </Title>
        <CasesContent>
          <Cases />
        </CasesContent>
      </CasesContainer>

      <VideoContainer>
        <VideoContent
          role="button"
          onClick={() => {
            TrackGoogleAnalyticsEvent(
              `Play - Comece aqui`,
              'Visualizar vídeo',
              location.pathname,
            );
            setOpenVideo(true);
          }}
        >
          <img
            src={videoThumb}
            alt={translate('landingPageStartVideoThumbImageAlt') ?? ''}
          />

          <div>
            <PlayCircle weight="fill" />

            <Title>
              <h3>{translate('landingPageStartSubtitle')}</h3>
              <h1>{translate('landingPageStartTitle')}</h1>
            </Title>

            <Description>
              <p>{translate('landingPageStartDescription')}</p>
            </Description>
          </div>
        </VideoContent>
      </VideoContainer>

      <ContactSales />

      <Modal
        visible={openVideo}
        setVisible={setOpenVideo}
        closeButton
        className="video-modal"
      >
        {videoIsLoading ? (
          <Skeleton
            data-testid="video-loading"
            data-cy="video-loading"
            style={{ height: '100%' }}
          />
        ) : null}

        <iframe
          ref={videoRef}
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/CMvCzJ82Td0?enablejsapi=1"
          title={translate('landingPageStartVideoTitle') ?? ''}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
          onLoad={() => setVideoIsLoading(false)}
          style={{ visibility: videoIsLoading ? 'hidden' : 'visible' }}
        />
      </Modal>
    </Container>
  );
}
